import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModulesService } from 'src/app/services/Authetication/menu-permission/modules.service';
import { Event, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterEvent, ActivatedRoute, UrlHandlingStrategy } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/services/Authetication/login.service';
import { NotificationService } from 'src/app/notification.service';
import { HttpClient } from '@angular/common/http';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { DatatransferService } from '../../../services/DataTransfer/datatransfer.service';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { map, catchError, retry, mapTo, switchMap, takeUntil } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { EventemitterService } from '../../../services/eventemitter.service';
import { SignalRService } from 'src/app/services/SignalR/signalR.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as commonConstant from '../../../../app/services/common.constant';
import { MatDialog } from '@angular/material/dialog';
import * as signalR from "@microsoft/signalr";
import * as moment from 'moment';
import { UserService } from 'src/app/services/Users/manage-user/user.service';
import { FormGroup,FormBuilder } from '@angular/forms';
import { LayoutSharedService } from 'src/app/services/utilization/layoutshared.service';
import { TeamService } from 'src/app/services/Teams/team.service';
import { VeriskAuthService } from 'src/app/services/Authetication/verisk-auth.service';
const ICONS_PATH = '../../../../assets/images/Menu_Icons/';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterViewInit  {

  Modules: any[] = [];
  loCurrentUserData: any;
  isLogIn: boolean = true;
  name!: string;
  teamName: string | undefined;
  profileImage: string | undefined;
  isSuperAdminUser: boolean = false;
  clientName: string | undefined;
  ipAddress: string | undefined;
  loginWithResponse: any;
  flgIsLoggedInWithEnabled: boolean = false;
  superAdminUserName: string | undefined;
  currentRoute: any;
  isEmitterCalled = false;
  superAdminId: string | undefined;
  notifications: any[] = [];
  unreadNotifications: any[] = [];
  teams: any[] = [];
  userteams: any[] = [];
  form!: FormGroup;
  private hubConnection!: signalR.HubConnection;
  @ViewChild('targetElement') targetElement!: ElementRef;
  private inactivityTime = 120 * 60 * 1000;
  private stopInactivityTimer$ = new Subscription();
  private idleTimer$ = new Subscription();
  private userHasInteracted = false;
  private isLoggedOut = false; 
  iconFolderPath: string = ICONS_PATH;
  /** True when current user is logged in via Verisk SSO (explicit flag + token; avoids stale veriskToken after normal login). */
  get isVeriskUser(): boolean {
    return this._veriskAuthService.isVeriskSsoSession();
  }

  /** True when current user is client admin (from role or currentUserData). */
  get isClientAdmin(): boolean {
    if (this.loCurrentUserData?.isClientAdmin === true) return true;
    try {
      const role = JSON.parse(localStorage.getItem('LoggedInRole') || '{}');
      return role?.role?.name?.toLowerCase() === 'client admin';
    } catch {
      return false;
    }
  }

  /** True when the menu module is Request(s) (case-insensitive match on route or display name). */
  isRequestsModule(module: { stRouterLink?: string; stDisplayName?: string }): boolean {
    const link = (module?.stRouterLink ?? '').toLowerCase();
    const name = (module?.stDisplayName ?? '').toLowerCase();
    return link === 'requests' || name === 'requests' || link === 'request' || name === 'request';
  }

  /** Menu row click hook; Requests is allowed for Verisk users. */
  onMenuRowClick(event: MouseEvent, module: { stRouterLink?: string; stDisplayName?: string }): void {
    void event;
    void module;
  }

  /** Team name shown in the header: last 5 characters only for Verisk users, full name otherwise. */
  getTeamDisplayName(stName: string): string {
    if (!stName) return stName;
    return this.isVeriskUser && stName.length > 5 ? stName.slice(-5) : stName;
  }

  /** True when user has a valid session so menu selection (active state) is allowed. Checks Verisk user (Verisk token) first, then standard accessToken. */
  get isAuthenticatedForMenu(): boolean {
    if (this._veriskAuthService.isVeriskSsoSession()) return true;
    try {
      const data = JSON.parse(localStorage.getItem('currentUserData') || '{}');
      return !!data?.accessToken;
    } catch {
      return false;
    }
  }

  constructor(
    private _router: Router,
    private _modulesService: ModulesService,
    private _dataService: DatatransferService,
    private _loginService: LoginService,
    private _Router: Router,
    private httpClient: HttpClient,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private _notificationService: NotificationService,
    private spinner: NgxSpinnerService,
    private eventEmitterService: EventemitterService,
    private _singlarService: SignalRService,
    private _modalService: NgbModal,
    private dialogRef: MatDialog,
    private _userService : UserService,
    private fb: FormBuilder,
    private sharedService: LayoutSharedService,
    private teamService: TeamService,
    private _veriskAuthService: VeriskAuthService
    )
    {
      this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
      localStorage.setItem('setnewpassword', 'true');
      _router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.currentRoute = _router.url
        if (_router.url != "/login" && _router.url != "/client/expiration" && _router.url != "/login?returnUrl=closeLoginPopup") {
          this.checkMenuAccess(_router.url);
        }
      });

      this.eventEmitterService.getUpdatedUserData().subscribe(data => {
        if (data != null && data != '' && data != undefined) {
          this.isEmitterCalled = true;
          this.ngOnInit();
        }
      })
      // Notification Portion start
      this.getClaimsNotification();
      this.startConnection();
      this.getNotifyInfo();
      // Notification Portion end

      this.startIdleTimer();
      this.trackUserActivity();

      this.form = this.fb.group({
        team: [null] // Initialize without a default value for now
      });
     }

     ngOnInit(): void {
      if (this.loCurrentUserData !== null && (this.loCurrentUserData != null || this.loCurrentUserData != '')) {
        this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
        
        // Initialize default values if only token exists (SSO flow)
        if (this.loCurrentUserData.accessToken && !this.loCurrentUserData.name) {
          console.log('[LAYOUT DEBUG] SSO token detected - initializing default values');
          this.name = this.loCurrentUserData.name || '';
          this.teamName = this.loCurrentUserData.teamName || '';
          this.profileImage = this.loCurrentUserData.profileImage || '../../../../assets/images/user-img.png';
          this.Modules = this.Modules || [];
          this.notifications = this.notifications || [];
          this.unreadNotifications = this.unreadNotifications || [];
          this.userteams = this.userteams || [];
        }
        
        this._dataService.sendDataBetweenComponents(this.loCurrentUserData);
        if (this.loCurrentUserData.isSuperAdmin == true) {
          this.isSuperAdminUser = true;
        }
        if (this.loCurrentUserData.isSuperAdmin == true && (localStorage.getItem('flgIsLoggedInAsUser') == null)) {
          localStorage.setItem('SuperAdminUserName', this.loCurrentUserData.name);
          localStorage.setItem('SuperAdminUserId', this.loCurrentUserData.userId);
          localStorage.setItem('SuperAdminUserRole', localStorage.getItem('LoggedInRole') || '');
        }

        if (this.loCurrentUserData.isClientAdmin == true && (localStorage.getItem('flgIsLoggedInAsUser') == null)) {
          localStorage.setItem('SuperAdminUserName', this.loCurrentUserData.name);
          localStorage.setItem('SuperAdminUserId', this.loCurrentUserData.userId);
          localStorage.setItem('SuperAdminUserRole', localStorage.getItem('LoggedInRole') || '');
        }

        if (localStorage.getItem('flgIsLoggedInAsUser') == "1") {
          this.superAdminUserName = (localStorage.getItem('SuperAdminUserName') || '').trim();
          this.superAdminId = localStorage.getItem('SuperAdminUserId') || '';
          this.flgIsLoggedInWithEnabled = true;
        }

        if (this.loCurrentUserData.clientName != undefined)
          this.clientName = this.loCurrentUserData.clientName;

        // Only get modules if roleId exists (skip for SSO token-only flow)
        if (this.loCurrentUserData.roleId) {
          this.getModulesByRoleId(this.loCurrentUserData.roleId);
        } else if (this.loCurrentUserData.accessToken) {
          console.log('[LAYOUT DEBUG] Token exists but no roleId - modules will be loaded when user info is available');
          // Initialize empty modules array to prevent template errors
          this.Modules = [];
        }
        this.loadScript('assets/js/main.js');
        this.getIPAddress();

        this.form = this.fb.group({
          team: ['']
        });
    
        // Listen for changes in the team dropdown
        if (!this.form.get('team')?.value) {
          localStorage.removeItem('selectedTeamId');
        }
        this.form.get('team')?.valueChanges.subscribe(selectedTeamId => {
          this.onTeamChange(selectedTeamId);
        });
      }
      else {
        this._router.navigate(['/login']);
      }
      this.getClientTeams();
      //this.getUserTeams();
  
      this._dataService.teamMessage.subscribe(message => {
        if (message.message == "removedUser") {
          let localStorageDate = JSON.parse(localStorage.getItem('currentUserData') || '{}');
          localStorageDate.teamId = "00000000-0000-0000-0000-000000000000"
          localStorageDate.teamName = "";
          localStorage.setItem('currentUserData', JSON.stringify(localStorageDate));
          this.teamName = "";
        }
        else if (message.message == "addedUser") {
          let localStorageDate = JSON.parse(localStorage.getItem('currentUserData') || '{}');
          localStorageDate.teamId = message.teamId;
          localStorageDate.teamName = message.teamName;
          localStorage.setItem('currentUserData', JSON.stringify(localStorageDate));
          this.teamName = message.teamName;
        }
      });

      this._dataService.currentMessage.subscribe(message => {
        if (message == "") {
          this.name = this.loCurrentUserData.name || '';
          this.teamName = this.loCurrentUserData.teamName || '';
          this.profileImage = this.loCurrentUserData.profileImage || '';
          if (this.profileImage == "") {
            this.profileImage = "../../../../assets/images/user-img.png"
          }
          else {
            this.profileImage = this.loCurrentUserData.profileImage;
          }
        }
        else {
          this.name = message.name || '';
          this.teamName = message.teamName || '';
          this.profileImage = message.profileImage || '';
          if (this.profileImage == "") {
            this.profileImage = "../../../../assets/images/user-img.png"
          }
          else {
            this.profileImage = message.profileImage;
          }
        }
      });

      if (this.isEmitterCalled) {
        this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
        this.name = this.loCurrentUserData.name || '';
        // this.teamName = this.loCurrentUserData.teamName;
      }
      this.getUserTeams();
      
      this.teamService.refreshTeams$.subscribe(() => {
        this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
        this.getUserTeams();
      })
    }

    ngAfterViewInit() {
      const rect = this.targetElement.nativeElement.getBoundingClientRect();
      const rightPosition = window.innerWidth - rect.right;
      const element = document.querySelector('.notification-right-spacing') as HTMLElement;
      if (element && rightPosition <= 245) {
        element.style.right = 'calc(-' + rightPosition + 'px + 30px)';
      }
    }
  
    onTeamChange(selectedTeamId: any): void {
      this._dataService.setValue(selectedTeamId); 
      // Pass the selected team ID to the shared service for global usage
      localStorage.setItem('selectedTeamId', selectedTeamId.toString());
    }

    getClientTeams() {
      this._userService.GetClientTeamByClientId(this.loCurrentUserData.clientId).subscribe({
        next: (response) => {
          if (!!response) {
            if (response.clientTeams != null && response.clientTeams.length > 0) {
              // Split the teamId string into an array
              if(this.loCurrentUserData.teamId != null && this.loCurrentUserData.teamId != ""){
              const teamIds = this.loCurrentUserData.teamId.toLowerCase().split(',');            
              
              // Filter clientTeams to only include those that match teamIds
              this.teams = response.clientTeams.filter((team: any) => teamIds.includes(team.uiTeamId.toLowerCase()));
              // Set the first matching team as the default selected value
              if (this.teams.length > 0) {
                this.form.get('team')?.setValue(this.teams[0]?.uiTeamId);
              }
              
              //this.teams = response.clientTeams;
              //// Set the first team as the default selected value
              //this.form.get('team')?.setValue(this.teams[0]?.uiTeamId);
            }
          }
          }
        },
        error: (error) => {
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
    }

    getUserTeams() {
      this._userService.GetUserTeamByUserId(this.loCurrentUserData.userId).subscribe({
        next: (response) => {
          if (!!response) {
            if (response.userTeams != null && response.userTeams.length > 0) {
              // Split the teamId string into an array
              
              // Filter userTeams to only include those that match teamIds
              this.userteams = response.userTeams;

              let localStorageData = JSON.parse(localStorage.getItem('currentUserData') || '{}');

             // Initialize teamDetails array if it doesn't exist
             localStorageData.teamDetails = [];
             this.sharedService.setUserTeams(this.userteams);
              
              // Loop through the teams and add each team details to the teamDetails array
              response.userTeams.forEach((team:any) => {
                const teamDetail = {
                  uiTeamId: team.uiTeamId,
                  stName: team.stName,
                  inReportType:team.inReportType
                };
                
                // Only add if not already in the teamDetails array
                if (!localStorageData.teamDetails.some((existingTeam:any) => existingTeam.uiTeamId === teamDetail.uiTeamId)) {
                  localStorageData.teamDetails.push(teamDetail);
                  // Update teamId string with all uiTeamIds joined by comma
                  localStorageData.teamId = localStorageData.teamDetails.map((team: any) => team.uiTeamId).join(',');
                }
              });
              
              // Save the updated localStorageData back to localStorage
              localStorage.setItem('currentUserData', JSON.stringify(localStorageData));

              // Get the updated localStorageData to access teamDetails
              if (localStorageData.teamDetails) {
                this.userteams = localStorageData.teamDetails;
              
                // Set the first matching team as the default selected value
                if (this.userteams.length > 0) {
                  this.form.get('team')?.setValue(this.userteams[0]?.uiTeamId);
                }
              }

              // Set the first matching team as the default selected value
              if (this.userteams.length > 0) {
                this.form.get('team')?.setValue(this.userteams[0]?.uiTeamId);
              }
              //this.teams = response.userTeams;
              //// Set the first team as the default selected value
              //this.form.get('team')?.setValue(this.teams[0]?.uiTeamId);
          }
          this.sharedService.setLayoutLoaded(true);
          }
        },
        error: (error) => {
          this.sharedService.setLayoutLoaded(true);
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          } else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", 'Error');
          }
        }
      });
    }

  checkMenuAccess(currentUrl:any) {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.loCurrentUserData.accessToken
      },
      params: { 'uiRoleId': this.loCurrentUserData.roleId }
    };
    return this.httpClient.get<any>(environment.WebApiURL + 'api/Authentication/GetModulesByRoleId', httpOptions).pipe(
      map(res => {
        let returnresult : any;
        if (res['Error']) {
          this._router.navigate(['/login']);//, { queryParams: { returnUrl: state.url } }
          returnresult = false;
        }
        else {
          var isPresent = res.data.modules.some(function (el:any) {
            return el.stRouterLink === currentUrl.slice(1)
          });
          if (this.loCurrentUserData !== null && (this.loCurrentUserData != null || this.loCurrentUserData != '')) {
            if (this.loCurrentUserData.isFlgIsClientExpired && !this.loCurrentUserData.isSuperAdmin) {
              this._router.navigate(["client/expiration"]);
            }
            if (currentUrl.indexOf("history") !== -1 || currentUrl.indexOf("viewclient") !== -1 || currentUrl.indexOf("profile-setting") !== -1) {
              returnresult = true;
            }
            if (this.loCurrentUserData !== null && (this.loCurrentUserData != null || this.loCurrentUserData != '') && isPresent) {
              returnresult = true;
            }
          }
          else {
            this._notificationService.showInfo("Access denied!", "Permission");
            this._router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
          }
        }
        return returnresult;
      }),
      catchError((err) => {
        if (err != undefined) {
          if (err.status == 401) {
            this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            console.log("checkMenuAccess error response - " + err.status);
					  this._router.navigate(['/login']);
          }
        }
        return of(false);
      })
    );
  }

  getModulesByRoleId(RoelId: any) {
    if(this._modulesService.modulesByRole)
      {
       this._modulesService.modulesByRole = JSON.stringify(this._modulesService.modulesByRole);
       this.Modules= JSON.parse(this._modulesService.modulesByRole)
      }
      else{
    this._modulesService.getModulesByRoleId(RoelId).subscribe({
      next: (response: any) => {
      this.Modules = response.data.modules;
    },
    error: (error:any) => {
      console.log('getModulesByRoleId - ' + error.status);
    }
    })}
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

  getIPAddress() {
    //this.http.get('https://geolocation-db.com/json/').subscribe({
      this.http.get(environment.IPAddressURL, { headers: { 'IgnoreInterceptor': '' } }).subscribe({
      next:(data:any) => {
        if (this.ipAddress == undefined || this.ipAddress == "") {
          //this.ipAddress = data.IPv4;
          this.ipAddress = data.ip;
          this.getIPAddress();
        }
      },
      error:(error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      // this.getIPAddress();
       this.ipAddress = "1::1"
      }

    })
  }

  public startConnection = () => {
    // The signalR connection start
    // Security hotfix HF-06 (FE-9): /Notify requires the session token. Stop any earlier connection so a
    // re-init does not keep a second socket, and read the current token on every (re)connect
    this.hubConnection?.stop();
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.WebApiURL}Notify`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => JSON.parse(localStorage.getItem('currentUserData') || '{}').accessToken || ''
      })
      .build();
    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err))
  }

  public getNotifyInfo = () => {
    // Whenever claim submitted or claim published this method will call
    this.hubConnection.on('SendMessage', (notification: Notification) => {
      this.getClaimsNotification();
    });
  }

  getClaimsNotification() {
    // To get notification list
    this._singlarService.getNotificationByUserId(this.loCurrentUserData.userId).subscribe({
      next: (response) => {
        if (!!response) {
          if (response.statusCode == 200) {
            if(response.data.notificationListByUserId) {
          this.notifications = response.data.notificationListByUserId;
          }
          this.unreadNotifications = this.notifications.filter(x => x.flgIsUnread == true);
          }
        }
      }
    })
  }

  markAllAsReadNotifications() {
    // To update notification
    this._singlarService.updateNotificationByUserId().subscribe({
      next: (response) => {
        if (!!response) {
          if (response.statusCode == 200) {
            this.getClaimsNotification();
          }
        }
      }
    })
  }

  logout(reload:boolean) {
    // Security hotfix HF-06 (FE-9): close the notification socket with the session
    this.hubConnection?.stop();
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');

    // Verisk user:
    // 1) Best-effort call our logout API with Bearer token (revokes/invalidates server-side session where applicable)
    // 2) Clear local session
    // 3) Full-page redirect to backend Verisk logout to clear HttpOnly cookies / complete IdP sign-out
    if (this.isVeriskUser) {
      const token = this.loCurrentUserData?.accessToken?.toString();
      const doRedirect = () => {
        this.clearLocalSessionAndVerisk();
        window.location.href = `${environment.WebApiURL}api/VeriskSso/logout?returnUrl=${encodeURIComponent(window.location.origin + '/verisk-logged-out')}`;
      };
      if (token) {
        this._loginService.logoutWithAccessToken(token).subscribe({
          next: () => doRedirect(),
          error: () => doRedirect()
        });
      } else {
        doRedirect();
      }
      return;
    }

    const accessToken = this.loCurrentUserData.accessToken?.toString();
    this._loginService.logout().pipe(retry(5)).subscribe(
      {
        next: (response:any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.teamMessage.subscribe(message => {
                if (message != "")
                  message.message = '';
              });
              this.clearLocalSessionAndVerisk();
              this._modalService.dismissAll();
              this.dialogRef.closeAll();
              this.removeGoogleLocalStorage();
              commonConstant.investigatorUser.isTeamViewEnable = null;
              this._router.navigate(['login']).then(() => {
                // if (reload) {
                //   location.reload();
                // }
              });
            }
          }
        },
        error: (error:any) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, "Error");
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal server error.", "Error"); // unknown error
          }
          else {
            this._notificationService.showError(error.error?.errorMessage ?? "Error", "Error");
          }
        }
      }
    );
  }

  /** Clear localStorage, sessionStorage, and all cookies on logout. */
  private clearLocalSessionAndVerisk(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.clearAllCookies();
  }

  /** Expire every cookie accessible from this origin. */
  private clearAllCookies(): void {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const name = cookie.split('=')[0].trim();
      if (name) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      }
    }
  }

  // logout() {
  //   this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
  //   this._dataService.teamMessage.subscribe(message => {
  //     if (message != "")
  //       message.message = '';
  //   });
  //   localStorage.removeItem("IsLogged");
  //   localStorage.removeItem('currentUserData');
  //   localStorage.removeItem('ViewClienName');
  //   localStorage.removeItem('LoggedInRole');
  //   localStorage.removeItem('userAddEditAction');
  //   localStorage.removeItem('teamAddEditAction');
  //   localStorage.removeItem('SuperAdminUserName');
  //   localStorage.removeItem('SuperAdminUserId');
  //   localStorage.removeItem('SuperAdminUserRole');
  //   localStorage.removeItem('currentViewClientExpiryDate');
  //   localStorage.removeItem('ProductObject');
  //   localStorage.removeItem('AgeReductionProductObject');
  //   localStorage.removeItem('ProductName');
  //   localStorage.removeItem('LoginwithcurrentUserData');
  //   localStorage.removeItem('LoginwithflgIsLoggedInAsUser');
  //   localStorage.removeItem('isClientActive');
  //   localStorage.removeItem('flgIsLoggedInAsUser');
  //   this.googleService.signOut(true);
  //   this._modalService.dismissAll();
  //   this.dialogRef.closeAll();
  //   this._router.navigate(['login']);
  // }

  // User Login With starts
  loginWithSuperAdmin() {
    this.spinner.show();
    var userId = localStorage.getItem('SuperAdminUserId');
    if (this.ipAddress == undefined){
      this.ipAddress = ":1:";
    }
    this._loginService.loginWith(userId, this.ipAddress, true, '00000000-0000-0000-0000-000000000000').subscribe(
      {
        next: (response:any) => {
        if (!!response) {
          if (response.statusCode == 200) {
            this.spinner.hide();
            this.loginWithResponse = response.data;
            localStorage.removeItem('currentUserData');
            localStorage.setItem('currentUserData', JSON.stringify(this.loginWithResponse));
            localStorage.setItem('flgIsLoggedInAsUser', "0");
            localStorage.setItem('LoggedInRole', localStorage.getItem('SuperAdminUserRole') || '');
            setTimeout(() => {
              this._dataService.sendDataBetweenComponents(this.loginWithResponse);
            }, 3000);
            if (!this.loginWithResponse.isflgIsSetupPassword) {
              window.location.href = "setnewpassward";
            }
            else {
              if (this.loginWithResponse.isSuperAdmin) {
                const loginSource = localStorage.getItem('loginSource');
                if ((this.loCurrentUserData.isReportReviewer && this.loCurrentUserData.clientName == "") || loginSource === 'report-reviewer') {
                    if (loginSource === 'report-reviewer') {
                        localStorage.removeItem('loginSource');
                    }
                    window.location.href = `report-reviewer`;
                } else {
                    window.location.href = `client/viewclient/${this.loCurrentUserData.clientId}`;
                }
              }
              else {
                window.location.href = 'parameters';
              }
            }
          }
        }
      },
      error:  (error) => {
        this.spinner.hide();
        this.loginWithResponse = {
          resultSet: []
        };
        if (error.status == 0) {
          this._notificationService.showError(error.message, 'Login With Error'); // unknown error
        }
        else if (error.status == 500) {
          this._notificationService.showError("Internal Server Error.", 'Login With Error');
        }
        else {
          this._notificationService.showError(
            error.error.errorMessage,
            'Login With Error'
          );
        }
      }
    });

  }

  removeGoogleLocalStorage() {
    localStorage.removeItem('IsSignUpWithGoogle');
    localStorage.removeItem('GoogleAuthentication');
  }

  private trackUserActivity() {
    const userActivity$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click')
    );

    userActivity$.subscribe(() => {
      if (!this.userHasInteracted) {
        this.userHasInteracted = true;
        this.idleTimer$.unsubscribe();
        this.startInactivityTimer();
      }
    });
  }

  private startIdleTimer() {
    this.idleTimer$ = timer(this.inactivityTime).subscribe(() => {
      if (this.isLoggedOut) return;
      this.isLoggedOut = true;
      this.logout(true);
      this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, 'Information');
    });
  }

  private startInactivityTimer() {
    const userActivity$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'click')
    );

    this.stopInactivityTimer$ = userActivity$.pipe(
      switchMap(() => timer(this.inactivityTime).pipe(takeUntil(userActivity$))) 
    ).subscribe(() => {
      if (this.isLoggedOut) return;
      this.isLoggedOut = true;
      this.logout(true);
      this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, 'Information');
    });
  }

  ngOnDestroy() {
    this.stopInactivityTimer$.unsubscribe();
    this.idleTimer$.unsubscribe();
    this.hubConnection?.stop();
  }
}